import styled from '@emotion/styled';

type ImageProps = {
  src: string;
  height: number;
  visible: boolean;
};

const DivWithBackground = styled.div<ImageProps>`
  height: ${(props) => props.height}px;

  background: url(${(props) => props.visible && props.src}) center 30%;
  background-size: cover;
`;

function CroppedImage({
  src,
  height,
  visible,
  onClick,
}: {
  src: string;
  height: number;
  visible: boolean;
  onClick?: () => void;
}) {
  return (
    <DivWithBackground
      onClick={onClick}
      src={src}
      height={height}
      visible={visible}
    />
  );
}

type PostFeedImagesPropsT = {
  imageUrls: string[];
  visible: boolean;
  onClick?: () => void;
};

function PostFeedImages({ imageUrls, visible, onClick }: PostFeedImagesPropsT) {
  return (
    <CroppedImage
      onClick={onClick}
      src={imageUrls[0]}
      height={200}
      visible={visible}
    />
  );
}
export default PostFeedImages;
